import React from 'react';
import Collapsible from 'components/Collapsible';
import {
	Wrapper,
	Header,
	DimensionsWrapper,
	TableList,
	NoData,
	RadioWrapper,
} from './RegionalData.styles';
import { RegionalTableContainer } from '../RegionalTable';
import { ApSimpleDropdown, ApRadio } from '@alixpartners/ui-components';
import { CATEGORY_OPTIONS, EXPORT_OPTIONS } from '../../constants';
import { getFormattedSpendWithSymbol } from 'utils/number';

export const RegionalData = ({
	categoryType,
	changeCategoryType,
	data,
	companies,
	currencySymbol,
	selectedCountry,
	selectedState,
	queryParams,
	spendType,
	dimension,
	tailSpendData,
	showTailSpend,
	onExport,
	pmiBreadcrumbs,
	showExplorePage,
}) => {
	const spendFormatter = value => {
		return value
			? getFormattedSpendWithSymbol(value, currencySymbol).toUpperCase()
			: '-';
	};
	return (
		<Wrapper>
			{data.length !== 0 && (
				<Header>
					<DimensionsWrapper>
						{CATEGORY_OPTIONS.map(option => (
							<RadioWrapper key={option.value}>
								<ApRadio
									id={option.value}
									name="category-type-options"
									value={option.value}
									checked={option.value === categoryType}
									onChange={changeCategoryType}
								>
									{option.label}
								</ApRadio>
							</RadioWrapper>
						))}
					</DimensionsWrapper>

					<ApSimpleDropdown
						iconName="outline_save_alt"
						onChange={onExport}
						options={[EXPORT_OPTIONS[1]]}
						label="Export"
					/>
				</Header>
			)}
			{data.length !== 0 ? (
				<TableList>
					{data.map(({ name, vendorsCount, spend }) => {
						const description = `${vendorsCount} vendor${
							vendorsCount > 1 ? 's' : ''
						} / ${spendFormatter(spend)} of spend`;
						const tailSpend = tailSpendData.find(item => item.region === name);

						return (
							<Collapsible key={name} header={name} subheader={description}>
								<RegionalTableContainer
									categoryType={categoryType}
									companies={companies}
									selectedCountry={selectedCountry}
									selectedState={selectedState}
									currencySymbol={currencySymbol}
									queryParams={queryParams}
									spendType={spendType}
									dimension={dimension}
									tailSpend={tailSpend}
									region={name}
									showTailSpend={showTailSpend}
									showExplorePage={showExplorePage}
									pmiBreadcrumbs={pmiBreadcrumbs}
								/>
							</Collapsible>
						);
					})}
				</TableList>
			) : (
				<NoData>No data found</NoData>
			)}
		</Wrapper>
	);
};

export default RegionalData;
